var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20966 33.145H103.855C105.075 33.145 106.064 34.1343 106.064 35.3547V86.1772H2.20966C0.989236 86.1772 0 85.1879 0 83.9675V35.3547C0 34.1343 0.989236 33.145 2.20966 33.145Z",
    fill: "#B5D5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.064 86.1775H2.20966C0.989236 86.1775 0 85.1883 0 83.9678V77.3389H106.064V86.1775Z",
    fill: "#2CDDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.705 69.415L132.581 66.2903L127.425 50.8226H128.161C129.382 50.8226 130.371 49.8331 130.371 48.613C130.371 47.3926 129.382 46.4033 128.161 46.4033H108.274C107.054 46.4033 106.064 47.3926 106.064 48.613V86.1775H114.903V92.8065L134.79 92.8075C136.011 92.8075 137 91.8183 137 90.5979V72.5404C137 71.3684 136.534 70.2443 135.705 69.415Z",
    fill: "#FFD164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.705 69.415L132.581 66.2903L127.425 50.8226H128.161C129.382 50.8226 130.371 49.8331 130.371 48.613C130.371 47.3926 129.382 46.4033 128.161 46.4033H108.274C107.054 46.4033 106.064 47.3926 106.064 48.613V92.8065L134.79 92.8075C136.011 92.8075 137 91.8183 137 90.5979V72.5406C137 71.3684 136.534 70.2443 135.705 69.415Z",
    fill: "#DBD9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.064 92.8062H134.79C136.011 92.8062 137 91.817 137 90.5966V86.1772H106.064V92.8062Z",
    fill: "#C9C6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.483 53.0319V64.0802C110.483 65.3007 111.473 66.2899 112.693 66.2899H132.58L127.424 50.8223H112.693C111.473 50.822 110.483 51.8115 110.483 53.0319Z",
    fill: "#C9C6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.903 57.4519V64.0808C114.903 65.3013 115.893 66.2905 117.113 66.2905H132.581L128.898 55.2422H117.113C115.893 55.2419 114.903 56.2312 114.903 57.4519Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.898 55.2417H117.113C115.893 55.2417 114.903 56.2309 114.903 57.4514V59.661H130.371L128.898 55.2417Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.903 95.0159H8.83857C7.61814 95.0159 6.62891 94.0267 6.62891 92.8062V86.1772H114.903V95.0159Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.904 103.855C119.785 103.855 123.742 99.898 123.742 95.0168C123.742 90.1357 119.785 86.1787 114.904 86.1787C110.022 86.1787 106.065 90.1357 106.065 95.0168C106.065 99.898 110.022 103.855 114.904 103.855Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.904 99.4358C117.344 99.4358 119.323 97.4572 119.323 95.0165C119.323 92.5758 117.344 90.5972 114.904 90.5972C112.463 90.5972 110.484 92.5758 110.484 95.0165C110.484 97.4572 112.463 99.4358 114.904 99.4358Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9836 103.855C46.8648 103.855 50.8217 99.898 50.8217 95.0168C50.8217 90.1357 46.8648 86.1787 41.9836 86.1787C37.1025 86.1787 33.1455 90.1357 33.1455 95.0168C33.1455 99.898 37.1025 103.855 41.9836 103.855Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9828 99.4358C44.4235 99.4358 46.4021 97.4572 46.4021 95.0165C46.4021 92.5758 44.4235 90.5972 41.9828 90.5972C39.5421 90.5972 37.5635 92.5758 37.5635 95.0165C37.5635 97.4572 39.5421 99.4358 41.9828 99.4358Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3069 103.855C29.188 103.855 33.145 99.898 33.145 95.0168C33.145 90.1357 29.188 86.1787 24.3069 86.1787C19.4257 86.1787 15.4688 90.1357 15.4688 95.0168C15.4688 99.898 19.4257 103.855 24.3069 103.855Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.307 99.4358C26.7477 99.4358 28.7263 97.4572 28.7263 95.0165C28.7263 92.5758 26.7477 90.5972 24.307 90.5972C21.8663 90.5972 19.8877 92.5758 19.8877 95.0165C19.8877 97.4572 21.8663 99.4358 24.307 99.4358Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 81.7579H132.581C131.36 81.7579 130.371 80.7686 130.371 79.5482V77.3386C130.371 76.1181 131.36 75.1289 132.581 75.1289H137V81.7579Z",
    fill: "#FAEBC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 137,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSide);
export default __webpack_public_path__ + "static/media/TruckSide.14c285a0d78fa1018492fa2d5f0ce751.svg";
export { ForwardRef as ReactComponent };